import classnames from 'classnames';
import { IconProps } from '../types';

/**
 * The NuPay mark, from Shopify's MIT-licensed payment_icons pack
 * (activemerchant/payment_icons). Kept as the scheme ships it, frame included.
 */
export default function NupayIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-5', className)} viewBox="0 0 38 24" style={style} role="img" aria-label="NuPay">
      <path
        opacity=".07"
        d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
        fill="#000"
      />
      <path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.627 18.17h2.907l.003-.033a.528.528 0 00.004-.06l-.003-1.716c-.003-1.59-.005-3.18-.012-4.77-.004-.72-.044-1.437-.24-2.137-.247-.878-.675-1.646-1.421-2.21-1.41-1.062-3.535-.903-4.817.354a.28.28 0 01-.2.083l-.114.007c-.22.013-.44.026-.656.066-1.6.296-2.842 1.598-3.023 3.195-.057.518-.057 1.044-.057 1.567-.004 1.354-.002 2.707 0 4.061L8 18.018v.148h2.912v-5.381c0-.172-.002-.345-.005-.518-.004-.283-.008-.565-.002-.848l.005-.21c.009-.474.018-.95.069-1.42a3.41 3.41 0 01.911-2.014.247.247 0 01.16-.08c.685.008 1.332.16 1.915.528.86.544 1.317 1.353 1.53 2.317.122.544.123 1.1.124 1.653v.164c.006 1.35.006 2.7.007 4.05l.001 1.619v.144zM30 6.828h-2.91v1.484l.008 5.388v.016c.002.56.004 1.122-.098 1.676-.127.693-.402 1.316-.89 1.838a.237.237 0 01-.148.077c-.74-.004-1.432-.182-2.045-.606-.795-.55-1.215-1.334-1.415-2.251-.12-.551-.121-1.112-.123-1.671v-.147a927.981 927.981 0 01-.007-4.087c0-.527 0-1.055-.002-1.582v-.132h-2.905c0 .012-.002.022-.003.03l-.003.048.005 1.878c.003 1.659.007 3.318.02 4.976.003.687.083 1.367.303 2.025.292.872.77 1.613 1.567 2.12 1.413.897 3.388.678 4.596-.504a.266.266 0 01.2-.084 5.11 5.11 0 00.567-.04c1.749-.233 3.12-1.655 3.25-3.393.034-.46.033-.922.033-1.383V6.828z"
        fill="#820AD1"
      />
    </svg>
  );
}
